import * as React from 'react'

export const SvgRewardPointsOutline = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg viewBox="0 0 24 24" aria-hidden={true} {...props}>
    <path d="M2 11a8 8 0 0114.559-4.582 8 8 0 11-9.117 12.164A8.003 8.003 0 012 11zm4.163 4.614a8 8 0 017.194-9.589 6 6 0 00-7.194 9.589zM14 20a6 6 0 100-12 6 6 0 000 12z" />
  </svg>
)
export default SvgRewardPointsOutline
